import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H12C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6V12C19 12.5523 19.4477 13 20 13C20.5523 13 21 12.5523 21 12V6C21 4.34315 19.6569 3 18 3H6ZM14.7645 12.5685C14.6164 12.4647 14.4222 12.466 14.2754 12.5716C14.1285 12.6772 14.0591 12.8657 14.1005 13.0462L16.1762 22.0937C16.2176 22.2742 16.3614 22.4098 16.5383 22.4353C16.7153 22.4608 16.8891 22.3709 16.9762 22.2089L18.6278 19.1374L21.7394 18.3669C21.9067 18.3255 22.0346 18.1852 22.0654 18.0094C22.0961 17.8336 22.0239 17.6556 21.8813 17.5556L14.7645 12.5685Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgInspect = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgInspect;
